// const backendURL = 'http://localhost:5037'
const backendURL = 'https://api.collectors.cafe'

export const config = {
  supportedNetworks: {
    1: 'Main Ethereum Network',
    // 3: 'Ropsten Testnet',
    // 42: 'Kovan Testnet',
    4: 'Rinkeby Test Network',
    137: 'Polygon',
  },
  backendURL: backendURL,
  backendLogInURL: `${backendURL}/metamask-signin`,
  backendAPIURL: `${backendURL}/api`,
  // backendSRAHttpURLRoot: `${backendURL}/sra/`,
  backendLogInExtendURL: `${backendURL}/api/metamask-refresh`,
  backendLogInMessage: 'I agree with the terms and conditions. Please sign me in.',  
  localStorageKey: {
    login: 'JWTUser',
  },
  cacheTime: {
    network: 1 * 60 * 1000, // miliseconds
    account: 1 * 60 * 1000,
  },
  AlchemyAPI: {
    1: {
      URLRoot: 'https://eth-mainnet.g.alchemy.com/nft/v2/_kxHB5GQtx6fDwUxMnfw73G4bmlQaIhk'
    },
    4: {
      URLRoot: 'https://rinkeby-api.Alchemy.io/api/v1'
    }
  },  
  moralisNetworkSymbol: {
    1: 'eth',
    // 4: 'rinkeby',
    137: 'polygon',
  },
  moralisAPI: {
    serverURL: 'https://zagjsxfjsakl.usemoralis.com:2053/server',
    applicationID: 'SYmtbZ4bK4aABdpQvNDURlwA24ZYY1xM82xqsB7N',
  },
  NFTPortNetworkName: {
    1: 'ethereum',
    // 4: 'rinkeby',
    137: 'polygon',
  },
  NFTPortAPI: {
    APIKey: 'a64fc7b8-65cc-406b-8f7b-9ccc2c36db90',
    URLRoot: 'https://api.nftport.xyz',
  },
  openseaAPI: {
    1: {
      URLRoot: 'https://api.opensea.io/api/v1'
    },
    4: {
      URLRoot: 'https://rinkeby-api.opensea.io/api/v1'
    },
    137: {
      URLRoot: 'https://api.opensea.io/api/v1'   // HACK!
    },
  },
  openseaAPIKey: '[replace]',
  openseaURL: {
    1: {
      assetPage: "https://opensea.io/assets/",
      collectionPage: "https://opensea.io/collection/",
      affiliateAddress: '0x0C1629c937119f8d7fA64bB4da488D642cc90469',
    },
    137: {
      assetPage: "https://opensea.io/assets/matic/",
      collectionPage: "https://opensea.io/collection/",
      affiliateAddress: '0x0C1629c937119f8d7fA64bB4da488D642cc90469',
    },
    4: {
      assetPage: "https://testnets.opensea.io/assets/",
      collectionPage: "https://testnets.opensea.io/collection/",
      affiliateAddress: '0x0C1629c937119f8d7fA64bB4da488D642cc90469',
    }
  },
  defaultRedirect: {
    logout: 'logout',
    publicHome: 'public-home',
    appHome: 'app-home',
    WalletNotConnected: 'logout',
    chainChange: 'logout',
    accountChange: 'logout',
  },
  network: {
    1: {
      id: 1,
      name: 'Main Ethereum Network',
      rpc: 'https://mainnet.infura.io/v3/2dba9736d8f64eb6b639fe233fea428c',
      // rpc: 'https://cloudflare-eth.com',
      txURL: 'https://etherscan.io/tx/',
      accountURL: 'https://etherscan.io/address/',
      tokenURL: 'https://etherscan.io/token/',
      etherscanApiURL: 'https://api.etherscan.io/',
    },
    4: {
      id: 4,
      name: 'Rinkeby Test Network',
      rpc: 'https://rinkeby.infura.io/v3/6f80e472f1764a03ba71ed250ebec918',
      txURL: 'https://rinkeby.etherscan.io/tx/',
      accountURL: 'https://rinkeby.etherscan.io/address/',
      tokenURL: 'https://rinkeby.etherscan.io/token/',
      etherscanApiURL: 'https://api-rinkeby.etherscan.io/',
    },
    137: {
      id: 137,
      name: 'Polygon',
      // rpc: 'https://kovan.infura.io/v3/2dba9736d8f64eb6b639fe233fea428c',
      txURL: 'https://polygonscan.com/tx/',
      accountURL: 'https://polygonscan.com/address/',
      tokenURL: 'https://polygonscan.com/token/',
      // etherscanApiURL: 'https://api-kovan.etherscan.io/',
    },
  },
}
